type Props = {
    src: string;
    className: string;
}

import { TransformWrapper, TransformComponent, useControls } from 'react-zoom-pan-pinch';

const ZoomInIcon = () => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
        <line x1="11" y1="8" x2="11" y2="14" />
        <line x1="8" y1="11" x2="14" y2="11" />
    </svg>
);

const ZoomOutIcon = () => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
        <line x1="8" y1="11" x2="14" y2="11" />
    </svg>
);

const ResetZoomIcon = () => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
        <path d="M3 3v5h5" />
    </svg>
);

const ZoomControls = () => {
    const { zoomIn, zoomOut, resetTransform } = useControls();

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.5rem",
                padding: "0.5rem",
                flexShrink: 0,
            }}
        >
            <button type="button" onClick={() => zoomIn()} aria-label="Zoom in" title="Zoom in" style={btnStyle}>
                <ZoomInIcon />
            </button>
            <button type="button" onClick={() => resetTransform()} aria-label="Reset zoom" title="Reset zoom" style={btnStyle}>
                <ResetZoomIcon />
            </button>
            <button type="button" onClick={() => zoomOut()} aria-label="Zoom out" title="Zoom out" style={btnStyle}>
                <ZoomOutIcon />
            </button>
        </div>
    );
};

const btnStyle = {
    width: 36,
    height: 36,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid rgba(255,255,255,0.2)",
    borderRadius: 6,
    background: "rgba(255,255,255,0.08)",
    color: "inherit",
    cursor: "pointer",
};

const ZoomViewer = ({src, className}: Props) => {
    return (
        <div
            style={{
                width: "100%",
                height: "100%",
                minHeight: 0,
                position: "relative",
            }}
        >
            <div
                style={{
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <TransformWrapper
                    initialScale={1}
                    centerOnInit
                    centerZoomedOut
                >
                    {() => (
                        <>
                            <TransformComponent
                                wrapperStyle={{
                                    width: "100%",
                                    height: "100%",
                                    flex: 1,
                                    minHeight: 0,
                                }}
                                contentStyle={{
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <img
                                    src={src}
                                    className={className}
                                    draggable={false}
                                    style={{
                                        maxWidth: "100%",
                                        maxHeight: "100%",
                                        objectFit: "contain",
                                        display: "block",
                                        margin: "auto",
                                    }}
                                />
                            </TransformComponent>
                            <ZoomControls />
                        </>
                    )}
                </TransformWrapper>
            </div>
        </div>
    )
}

export default ZoomViewer;